import { render, staticRenderFns } from "./StpTable.vue?vue&type=template&id=143d50fe&"
import script from "./StpTable.vue?vue&type=script&lang=ts&"
export * from "./StpTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports